(() => {
  'use strict';

  const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');

  const imageOverrides = {
    image_with_text_9k7t3F: {
      heading: 'Expert prévention, dépistage et accompagnement réglementaire',
      headingSize: 'h1',
      text: '<p>AMA Prévention accompagne les entreprises, collectivités, établissements recevant du public et acteurs de prévention sur des sujets sensibles : dépistage des stupéfiants, sécurité routière, prévention en entreprise, Plan Joana, soumission chimique, vulnérabilité chimique et violences sexistes et sexuelles.</p><p><strong>Une approche d’expert-conseil :</strong> dispositifs fiables, compréhension réglementaire, expérience terrain et solutions réellement utilisables.</p><p><strong>Une expertise dédiée aux organisations et aux acteurs de la prévention.</strong></p>',
      buttonLabel: 'Demander un devis personnalisé',
      buttonLink: '/pages/demande-de-devis'
    },
    image_with_text_wYHzDV: {
      heading: 'B-SAFE : détecteur connecté de substances dans les boissons',
      headingSize: 'h2',
      text: '<p><strong>Innovation française disponible :</strong> B-SAFE est un détecteur électronique connecté développé par <strong>LUEUR</strong> pour analyser rapidement une boisson suspecte et renforcer les protocoles de prévention de la soumission chimique.</p><p>Une solution professionnelle destinée aux bars, clubs, festivals, soirées étudiantes, collectivités, associations et établissements recevant du public.</p>',
      buttonLabel: 'Découvrir B-SAFE',
      buttonLink: '/products/b-safe-stylo-detecteur-drogues-boissons'
    },
    image_with_text_wiMnPB: {
      heading: 'Marque « Utilisé par les Armées Françaises » : un repère institutionnel',
      headingSize: 'h2',
      text: '<p>La marque <a href="/blogs/entreprises/tests-de-depistage-drogues-toda-pharma-valides-par-l-armee-francaise" title="Tests de dépistage Toda Pharma utilisés par les Armées françaises">« Utilisé par les Armées Françaises » (UAF)</a> signale l’usage de certaines références Toda Pharma par les armées françaises. Elle constitue un repère institutionnel ; elle ne remplace ni le marquage CE, ni les certifications du fabricant, ni les conditions d’utilisation propres à chaque dispositif.</p>'
    },
    image_with_text_nVYwmh: {
      heading: '<strong>Tests salivaires et urinaires Toda Pharma Drugdiag®</strong>',
      headingSize: 'h2',
      text: '<p>Découvrez les tests de dépistage Drugdiag® pour rechercher le THC, la cocaïne, les opiacés et d’autres substances selon la référence choisie. Ils sont fabriqués par Toda Pharma dans le cadre d’un système qualité certifié <strong>ISO 13485</strong> et portent le <strong>marquage CE</strong> selon les dispositifs concernés. AMA Prévention vous aide à sélectionner le format adapté à la sécurité routière, à la prévention en entreprise ou à l’auto-contrôle.</p>',
      buttonLabel: 'Commander les tests Drugdiag®',
      buttonLink: '/collections/tests-salivaires-drugdiag'
    },
    image_with_text_dbRerk: {
      heading: 'Éthylotests électroniques et chimiques : choisir selon l’usage',
      headingSize: 'h2',
      text: '<p>Découvrez une sélection d’éthylotests destinée aux entreprises, aux événements et aux particuliers. Selon la fréquence d’utilisation et le contexte, comparez les formats électroniques et chimiques, leurs conditions d’emploi et leur niveau de précision afin de choisir un dispositif réellement adapté.</p>',
      buttonLabel: "Voir notre gamme d'éthylotests",
      buttonLink: '/collections/ethylotests'
    },
    image_with_text_VgFfPK: {
      heading: '<strong>Sensibilisation, protocoles et dépistage en entreprise</strong>',
      headingSize: 'h2',
      text: '<p>Structurez votre démarche de prévention des conduites addictives : évaluation des risques, règlement intérieur, sensibilisation, formation des personnes habilitées et campagnes de dépistage adaptées à votre contexte.</p><p><strong>Nos interventions peuvent inclure :</strong></p><ul><li>Sensibilisation aux risques addictifs et au risque routier.</li><li>Accompagnement des managers et des personnes habilitées.</li><li>Protocoles et campagnes de dépistage proportionnés aux postes et aux risques.</li></ul>',
      buttonLabel: 'Nos offres entreprises',
      buttonLink: '/pages/ama-prevention-votre-partenaire-pour-une-entreprise-sure-et-responsable'
    },
    image_with_text_UyQaWy: {
      heading: 'Toda Pharma, fier porteur du label Cœur Alsace',
      headingSize: 'h2',
      text: '<p>Le label « Cœur Alsace » met en avant l’ancrage territorial et le savoir-faire local de Toda Pharma. Implanté à Strasbourg, le laboratoire développe et fabrique des dispositifs de diagnostic rapide dans un cadre qualité exigeant, au service de la santé et de la prévention.</p>'
    }
  };

  const domainOverrides = [
    { title: '<strong>Sécurité au travail</strong>', text: '<p>Intégrez la <strong>prévention des conduites addictives</strong> au DUERP, aux procédures internes et à la protection des postes à risques.</p>', linkLabel: 'Découvrir', link: '/pages/espace-entreprise' },
    { title: '<strong>Prévention routière</strong>', text: '<p>Structurez une démarche de <strong>prévention du risque routier</strong> avec des outils adaptés, une information claire et des protocoles proportionnés.</p>', linkLabel: 'Découvrir', link: '/pages/reduire-le-risque-routier-professionnel' },
    { title: '<strong>Soumission chimique</strong>', text: '<p>Renforcez la prévention avec <strong>B-SAFE</strong>, les bracelets et les cartes <strong>Test Ton Verre®</strong> : des outils de détection et de vigilance adaptés aux bars, festivals, soirées et particuliers.</p>', linkLabel: 'Découvrir', link: '/pages/prevention-soumission-chimique-discotheques-bars-festivals-concerts' },
    { title: 'Événementiel', text: '<p>Festivals, concerts, soirées étudiantes : concevez un <strong>dispositif de prévention cohérent</strong>, adapté au public, au lieu et aux équipes mobilisées.</p>', linkLabel: 'Découvrir', link: '/pages/prevention-soumission-chimique-discotheques-bars-festivals-concerts' },
    { title: '<strong>Prévention antidopage</strong>', text: '<p>Informez les <strong>sportifs et encadrants</strong> sur les risques, les substances et les démarches de prévention, avec un accompagnement adapté au contexte.</p>', linkLabel: 'Être accompagné', link: '/pages/service-client-prevention-7j-7' }
  ];

  const sectionRoot = (handle) => document.querySelector(`[id$="__${handle}"]`);

  function replaceTag(element, tagName) {
    if (!element || element.tagName === tagName.toUpperCase()) return element;
    const replacement = document.createElement(tagName);
    [...element.attributes].forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
    while (element.firstChild) replacement.appendChild(element.firstChild);
    element.replaceWith(replacement);
    return replacement;
  }

  function optimizeHeadingSemantics() {
    const logoHeading = document.querySelector('.header__heading');
    if (logoHeading?.tagName === 'H1') replaceTag(logoHeading, 'div');
    if (!isFrench) return;
    const heading = sectionRoot('image_with_text_9k7t3F')?.querySelector('.image-with-text__heading');
    if (heading) replaceTag(heading, 'h1');
  }

  function optimizeImageSections() {
    if (!isFrench) return;
    Object.entries(imageOverrides).forEach(([handle, data]) => {
      const root = sectionRoot(handle);
      if (!root || root.dataset.amaHomepageOptimized === 'true') return;
      let heading = root.querySelector('.image-with-text__heading');
      const text = root.querySelector('.image-with-text__text');
      const button = root.querySelector('.button');
      if (handle === 'image_with_text_9k7t3F') heading = replaceTag(heading, 'h1');
      if (heading && data.heading) {
        heading.innerHTML = data.heading;
        heading.classList.remove('h0', 'h1', 'h2', 'hxl', 'hxxl');
        heading.classList.add(data.headingSize || 'h2');
      }
      if (text && data.text) text.innerHTML = data.text;
      if (button && data.buttonLabel) {
        button.textContent = data.buttonLabel;
        if (data.buttonLink) {
          button.href = data.buttonLink;
          button.removeAttribute('role');
          button.removeAttribute('aria-disabled');
        }
      }
      root.dataset.amaHomepageOptimized = 'true';
    });
  }

  function optimizeFeaturedCollection() {
    if (!isFrench) return;
    const title = sectionRoot('featured_collection_pFPAYN')?.querySelector('.collection__title .title');
    if (title) title.textContent = 'Bracelets et cartes Test Ton Verre®';
  }

  function optimizeDomainCards() {
    if (!isFrench) return;
    const root = sectionRoot('multicolumn_QzNCQp');
    if (!root) return;
    root.querySelectorAll('.multicolumn-list__item').forEach((item, index) => {
      const data = domainOverrides[index];
      if (!data || item.dataset.amaHomepageOptimized === 'true') return;
      const card = item.querySelector('.multicolumn-card');
      const info = item.querySelector('.multicolumn-card__info');
      if (!card || !info) return;
      const title = info.querySelector('h3');
      const text = info.querySelector('.rte');
      info.querySelector('a.link')?.remove();
      if (title) title.innerHTML = data.title;
      if (text) text.innerHTML = data.text;
      const label = document.createElement('span');
      label.className = 'ama-home-domain-label';
      label.textContent = `${data.linkLabel} →`;
      info.appendChild(label);
      const overlay = document.createElement('a');
      overlay.className = 'ama-home-domain-hit';
      overlay.href = data.link;
      overlay.setAttribute('aria-label', `${data.linkLabel} : ${title?.textContent.trim() || ''}`);
      overlay.innerHTML = '<span class="visually-hidden">Accéder à cette rubrique</span>';
      card.appendChild(overlay);
      item.dataset.amaHomepageOptimized = 'true';
    });
  }

  function optimizePressLink() {
    if (!isFrench) return;
    const bfm = sectionRoot('custom_liquid_LAw3HD')?.querySelector('.ama-logo-card[href*="ama-prevention.com/de/pages/interview"]');
    if (!bfm) return;
    bfm.href = '/pages/presse-medias';
    bfm.removeAttribute('target');
    bfm.removeAttribute('rel');
  }

  function run() {
    optimizeHeadingSemantics();
    optimizeImageSections();
    optimizeFeaturedCollection();
    optimizeDomainCards();
    optimizePressLink();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();